import styled from "styled-components";
import firstBackgroundCareer from "../../assets/background-career-1.svg";
import secondBackgroundCareer from "../../assets/background-career-2.svg";
import { devices } from "../../utilities/responsive";

export const FirstBackground = styled.div`
  width: 100vw;
  height: 12.5%;
  position: absolute;
  top: -30px;
  z-index: 1;
  background-image: url(${firstBackgroundCareer});
  background-size: 200vw 100vw;
  background-position: 41% 100%;
  background-repeat: no-repeat;
  @media ${devices.phoneLg} {
    display: none;
  }
`;
export const SecondBackground = styled.div`
  width: 100vw;
  height: 100%;
  position: absolute;
  background-image: url(${secondBackgroundCareer});
  background-size: 100vw 120vw;
  background-position: bottom;
  background-repeat: no-repeat;
  @media ${devices.desktopLg} {
    top: -40%;
  }

  @media ${devices.phoneLg} {
    display: none;
  }
`;
export const CaseStudyContainerFlex = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const WelcomeText = styled.div`
  margin-top: 10%;
  margin-bottom: 5%;
  z-index: 1;
  p {
    font-weight: 700;
  }
`;

export const Articles = styled.div`
  width: 100%;

  @media ${devices.tabletLandscape} {
    order: 2;
  }
`;
export const CaseStudyMainArticlesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr auto;
  column-gap: 40px;
  row-gap: 20px;
  margin: 0 0 80px 0;
  @media ${devices.tabletLandscape} {
    grid-template-columns: repeat(2, 1fr);
  }
  @media ${devices.tabletPortrait} {
    grid-template-columns: repeat(1, 1fr);
  }
`;
export const Filter = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 100px;
  width: 100%;

  @media ${devices.tabletLandscape} {
    position: initial;
    order: 1;
  }
`;
